import React from 'react'
import { getOauthSignupURL } from 'src/dataLayer/env'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton'

import OauthButtonIcon from './OauthButtonIcon'

export default ({ appType, provider }) => {
  const { locale } = useRouteParamsContext()
  const buttonIcon = OauthButtonIcon(provider)

  return (
    <TrackableButton
      buttonIcon={buttonIcon}
      dataTestid={`oauthButton-${provider}`}
      fullWidth={false}
      href={getOauthSignupURL(locale, provider)}
      minWidth="31%"
      title="Oauth button"
      trackingId={`${appType}:${provider}`}
    />
  )
}
